import React from 'react'
import { Link } from 'newComponents'

const Button = ({ url, text }) => (
  <div className="columns is-centered cta-padding">
    <Link to={url}>
      <div className="button is-large is-primary border-radius-2" tabIndex="0">
        <span className="navbar-item-name">{text}</span>
      </div>
    </Link>
  </div>
)

export default Button
